module.exports = __webpack_public_path__ + "static/img/index-right-radius.8b36e10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index-right-radius.png
// module id = Ik9o
// module chunks = 0